import moment from "moment";

/** Valor máximo del modelo: convención de «sin fin de vida útil». */
export const VIDA_UTIL_SIN_LIMITE = 99;

export function isVidaUtilSinLimite(vidaUtil) {
  const n = Number(vidaUtil);
  return !Number.isNaN(n) && n >= VIDA_UTIL_SIN_LIMITE;
}

export function formatVidaUtilLabel(vidaUtil) {
  if (isVidaUtilSinLimite(vidaUtil)) return "Sin límite";
  if (vidaUtil == null || vidaUtil === "") return "No especificado";
  return String(vidaUtil);
}

/** Para Excel/UI: fecha Date, texto «Sin límite», o null si no aplica. */
export function formatFinVidaUtilValue(item) {
  if (isVidaUtilSinLimite(item?.modelo?.vida_util)) {
    return "Sin límite";
  }
  if (!item?.fecha_fin_vida_util) return null;
  return moment(item.fecha_fin_vida_util).toDate();
}
